import { CommonModule } from '@angular/common';
import { Directive, HostListener, NgModule } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TermsAndConditionsDialogComponent } from '@telespot/ui';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[appTermsPopupTrigger]',
    standalone: false
})
export class TermsPopupTriggerDirective {
  @HostListener('click') onclick() {
    this.openDialog();
  }

  openDialog() {
    this._dialog.open(TermsAndConditionsDialogComponent, {
      width: '800px',
      maxWidth: '95vw',
      hasBackdrop: true,
      disableClose: false,
    });
  }

  constructor(private _dialog: MatDialog) {}
}

@NgModule({
  declarations: [TermsPopupTriggerDirective],
  imports: [CommonModule],
  exports: [TermsPopupTriggerDirective],
  providers: [],
})
export class TermsPopupTriggerModule {}
